import React, {Component} from 'react'
import { Row, Col} from 'antd';
import { Breadcrumb } from '../common/atoms';
import { Spin, Card, Avatar } from 'antd'

const { Meta } = Card;

class AccountManagers extends Component {

  constructor(props) {
    super(props)
    this.state = {
    	loading: false,
        account_managers: []
    }
  }

  componentDidMount(){
    let that = this
    let url = window.API_URL + 'corporate/account_managers'
    window.axios.get(url)
    .then(function (response) {
      that.setState({loading: false, account_managers: response.data})
    })
    .catch(function (error) {
      that.setState({loading: false})
      console.log(error);
    })
  }

  renderAccountManagers(){
    let managers = this.state.account_managers
    let output = managers.map((manager) => { 
        return(
          <Col span={8} style={{marginBottom: 15, paddingRight: 15}}>
            <Card>
              <Meta
                avatar={<Avatar src="https://res.cloudinary.com/ekincare/image/upload/v1536573111/hr_dashboard_overview/app_users.svg" />}
                title={'Name: ' + manager.name}
                description={this.renderManagerDetails(manager)}
              />
            </Card>
          </Col>
        )
    })
    return output
  }

  renderManagerDetails(manager){
    return(
      <div>
        <h4>Mobile: {manager.mobile}</h4>
        <h4>Email: {manager.email}</h4>
      </div>
    )
  }

  render(){
    return(
        <div>
          <Spin spinning={this.state.loading}>
          <Breadcrumb list={[{ text: 'Account Managers', link: '#' }]} classes='mb-1' />
            <Row>
              {this.renderAccountManagers()}
            </Row>
            <br/>
            <br/>
            <Row>
              <h4 className='semibold'>Note: If You have any queries you can call/email account managers anytime.</h4>
            </Row>
          </Spin>      
        </div>
    )
  }

}

export default AccountManagers;  
